import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SectionTitle from "../../common/SectionTitle/SectionTitle";
import ListCard from "../../cards/ListCard/ListCard";
import listCardsData from "../../../data/listCardsData";
import { useTranslation } from "react-i18next";
import './HomeHighlightSectionOne.css'

import HighlightBannerOne from '../../../assets/images/banner-1.png'

export default function HomeHighlightSectionOne() {

    const { t } = useTranslation();

    return (
        <section>
            <Container fluid>
                <Row>
                    <Col md={6}>
                        <img src={HighlightBannerOne} className="highlightBannerOne rounded-2 mb-md-2" />
                    </Col>

                    <Col md={6}>
                        <SectionTitle
                            subtitle={t("common.sectionTitles.homeReliabilitySecSubtitle")}
                            title={t("common.sectionTitles.homeReliabilitySecTitle")}
                            align="left"
                        />
                        <p className="brand-section-desc">
                            {t("common.staticTexts.homeReliabilitySecTagline")}
                        </p>

                        {/* {listCardsData.map((item) => (
                            <Col key={item.id} lg={12}>
                                <ListCard
                                    icon={item.icon}
                                    title={t(item.title)}
                                    description={item.description}
                                />
                            </Col>
                        ))} */}

                        {listCardsData.map((item) => (
                            <Col key={item.id} lg={12}>
                                <ListCard
                                    icon={item.icon}
                                    titleKey={item.titleKey}
                                    descriptionKey={item.descriptionKey}
                                />
                            </Col>
                        ))}
                    </Col>
                </Row>
            </Container>
        </section>
    );
}